import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cant-find-what-your-looking-for',
  templateUrl: './search-cant-find-what-your-looking-for.component.html',
  styleUrls: ['./search-cant-find-what-your-looking-for.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchCantFindWhatYourLookingForComponent {}
